import fetch, { wymsFetch } from '@/utils/fetch';

// 统一处理请求参数
export const filterURLSearchParams = (args = {}) => {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 数据统计
export const queryStatistic = params =>
    wymsFetch({
        url: 'statisticsWY/queryStatistic',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 用户增量统计信息
export const getAddUsers = params =>
    wymsFetch({
        url: 'statisticsWY/getAddUsers',
        method: 'GET',
        params: filterURLSearchParams(params)
    })

// 用户登录统计
export const getUserLoginCount = params =>
    wymsFetch({
        url: 'statisticsWY/getUserLoginCount',
        method: 'GET',
        params: filterURLSearchParams(params)
    })


// WEBPACK FOOTER //
// ./src/api/platformDataStatistics.js